import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import "../styles/pages/HomePage.scss";
import { useCallback, useEffect, useRef } from "react";

const HomePage: React.FC = () => {
  const { instance, inProgress } = useMsal();
  const loginAttempted = useRef(false);

  const handleLogin = useCallback(() => {
    // Only attempt login once and not during authentication flow
    if (!loginAttempted.current && inProgress === "none") {
      loginAttempted.current = true;
      instance.loginRedirect(loginRequest).catch((_e) => {
        loginAttempted.current = false; // Allow retry on error
      });
    }
  }, [instance, inProgress]);

  useEffect(() => {
    // Don't auto-login if:
    // 1. We're already in the middle of an auth flow (inProgress !== "none")
    // 2. We're processing an OAuth callback (hash contains code= or state=)
    // 3. We already have accounts (user is logged in)
    const hasAuthCallback =
      window.location.hash.includes("code=") ||
      window.location.hash.includes("state=");
    const hasAccounts = instance.getAllAccounts().length > 0;

    if (!hasAuthCallback && !hasAccounts && inProgress === "none") {
      handleLogin();
    }
  }, [handleLogin, instance, inProgress]);

  return <></>;
};
export default HomePage;
